<template>
  <div class="sticky top-0 z-10 flex w-full flex-col gap-1 bg-white p-3">
    <div class="flex items-center justify-between gap-2">
      <h4 class="flex text-infra-highlight-500">
        {{ panelName }}
        <ToolTip
          v-if="
            updatedInfo &&
            updatedInfo.map((e) => e.value).some((v) => v === true)
          "
          tooltip-icon-fill="#00A1D1"
          tooltip-icon="warn-sign-filled"
        >
          <template #text>
            <ul class="list-inside list-disc">
              <li
                v-for="update in updatedInfo?.filter((e) => e.value)"
                :key="update.index"
              >
                <span>{{ update.text }}</span>
              </li>
            </ul>
          </template>
        </ToolTip>
      </h4>
      <img
        class="h-4 w-4 cursor-pointer"
        src="@/assets/svg/minus-icon.svg"
        alt="close"
        data-test="close-info-panel"
        @click="emit('closeClick')"
      />
    </div>
  </div>
</template>

<script setup>
import ToolTip from '@/components/storybook/src/stories/toolTip/ToolTip.vue';

const emit = defineEmits(['closeClick']);
const props = defineProps({ panelName: String, updatedInfo: Object });
</script>
